<template>
    <div class="headContent">
        <div class="headTopBox">
            <img src="../assets/icon/headTopLogo.png" class="headTopLogo">
            <div class="headTopNavList align">
                <div :class="['headTopNav',active == index && !isMy ? 'headTopNavOn' : '']" v-for="(item,index) in headData.nav" :key="index">{{item.name}}</div>
            </div>
            <div class="headTop align">
                <div class="headTopLogin" @click="getMy" v-if="userDetail == '0'">免费注册</div>
                <div class="headTopLoginIcon"></div>
                <div class="headTopLogin" @click="getLogin" v-if="userDetail == '0'">登录</div>
                <div class="headTopLogin" @click="removeLogin" v-else>退出</div>
            </div>
        </div>
        <div class="headCenter" v-if="!isMy">
            <div class="logoBox align" @click="logoTap">
                <el-image v-if="headData.logo" :src="headData.logo" fit="cover" class="logo"></el-image>
                <div class="appName">{{ headData.name }}</div>
            </div>
            <div class="hcCenter">
                <div class="hcSearchBox">
                    <!-- <input v-model="input" placeholder="搜索服务" class="searchIpt" /> -->
                    <el-input v-model="input" placeholder="搜索服务" clearable class="searchIpt"></el-input>
                    <div class="hcSearchBtn" @click="hcSearchBtnTap()">搜索</div>
                </div>
                <div class="searchBox" v-if="headData.hotsearch && headData.hotsearch.length > 0">
                    <img src="../assets/icon/searchIcon.png" class="searchIcon">
                    <div class="searchList">
                        <div class="searchItem" v-for="(item,index) in headData.hotsearch" :key="index">{{item.title}}</div>
                    </div>
                </div>
            </div>
            <el-image v-if="headData.hehuorenlogo" :src="headData.hehuorenlogo" fit="cover" class="gift" @click="headNavTap()"></el-image>
        </div>
        <el-image :src="require('@/assets/image/loginBg.jpg')" fit="cover" style="width:0;height:0;position: fixed;left: -100px;top: -100px;"></el-image>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                userDetail: 0,
                headData: {},
                value: '',
                input: '',
                active: 0,
                isMy: false
            }
        },
        watch:{
            $route(to,from){
                if(from.path == '/login/login'){
                    this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
                }
                this.isMy = to.path == '/my/my' ? true : false
                console.log(to.path)
                console.log(this.isMy)
            }
        },
        created() {
            window.addEventListener('keydown', this.searchKey, true)//开启监听键盘按下事件
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getAppHead()
        },
        methods: {
            // 网站头数据
            getAppHead(){
                this.request.get("index/index/top",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.headData = res.data
                })
            },
            // logo点击
            logoTap(){
                this.$router.push({ path:'/' })
            },
            selChange(e){
                console.log(e)
            },
            // 跳转我的订单
            getMy(){
                // this.$router.push({ path:'/my/my', query:{type: 'order'} })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 退出登录
            removeLogin(){
                localStorage.removeItem('userInfo')
                this.$router.go(0)
            },
            // tab切换
            headTabTap(i,e){
                this.active = i
                this.$router.push({ path:e })
            },
            // 自定义跳转
            headNavTap(e){
                if(this.userDetail == '0'){
                    this.getLogin()
                }else{
                    this.$router.push({ path:e })
                }
            },
            searchKey(e){
                if(e.keyCode === 13 && this.$route.path != '/login/login' && this.$route.path != '/my/my'){
                    this.hcSearchBtnTap()
                }
            },
            // 搜索
            hcSearchBtnTap(){
                if(this.input == ''){
                    this.$message({
                        message: '请输入您要搜索的内容',
                        type: 'warning'
                    });
                }else{
                    // if(this.$route.path == '/search/search' && this.$route.query.key != this.input){
                    //     this.$router.push({query:{key:this.input} })
                    // }
                    // if(this.$route.path != '/search/search'){
                    //     this.$router.push({ path:'/search/search', query:{key:this.input} })
                    // }
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .headContent{
        width: 100vw;
        background: linear-gradient(to bottom, #E3EEFF, #F7F8FA);
        .headTopBox{
            width: 1232px;
            height: 80px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            border-bottom: 1px solid #DEEBFF;
            .headTopLogo{
                width: 132px;
                height: 27px;
                margin-top: 30px;
            }
            .headTopNavList{
                height: 80rpx;
                .headTopNav{
                    padding: 0 27px;
                    font: 16px/80px "Microsoft YaHei";
                    color: #ADACB1;
                    cursor: pointer;
                    &:hover{
                        color: #73727A;
                    }
                }
                .headTopNavOn{
                    color: #000;
                }
            }
            .headTop{
                height: 80px;
                display: flex;
                flex-direction: row-reverse;
                .headTopLogin{
                    font: 14px/80px "Microsoft YaHei";
                    color: #47474F;
                    cursor: pointer;
                }
                .headTopLoginIcon{
                    width: 1px;
                    height: 13px;
                    background: #ADACB1;
                    margin: 0 22px;
                }
            }
    }
        .headCenter{
            width: 1232px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 auto;
            .logoBox{
                height: 56px;
                cursor: pointer;
                .logo{
                    width: 56px;
                    height: 56px;
                }
                .appName{
                    font: bold 24px/56px "Microsoft YaHei";
                    padding-left: 10px;
                }                  
            }
            .hcCenter{
                .hcSearchBox{
                    width: 580px;
                    height: 38px;
                    display: flex;
                    align-items: center;
                    border: 1px solid #0F59FE;
                    border-radius: 4px;
                    overflow: hidden;
                    .searchIpt{
                        width: 500px;
                        height: 38px;
                        // padding: 0 10px;
                        // border-left: 1px solid #EBECEE;
                        font: 16px/38px "Microsoft YaHei";
                        color: #6D6D6D;
                        // :deep(.el-input__wrapper) {
                        //     box-shadow: 0 0 0 0px var(--el-input-border-color, var(--el-border-color)) inset;
                        //     cursor: default;
                        //     .el-input__inner {
                        //         cursor: default !important;
                        //     }
                        // }
                        /deep/ .el-input__inner {
                            border: none;
                        }
                    }
                    .hcSearchBtn{
                        flex: 1;
                        height: 38px;
                        background: #0F59FE;
                        font: 16px/38px "Microsoft YaHei";
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                    }
                }
                .searchBox{
                    padding-top: 8px;
                    display: flex;
                    align-items: center;
                    .searchIcon{
                        width: 51px;
                        height: 19px;
                    }
                    .searchList{
                        display: flex;
                        .searchItem{
                            font: 12px/12px "Microsoft YaHei";
                            color: #6D6D6D;
                            padding: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .gift{
                width: 218px;
                height: 92px;
                cursor: pointer;
            }
        }
    }
</style>